const Cmin_formula = "C_(si) = Da + a - Da / 2";
const inlineFormula = "\\cos (2\\theta) = \\cos^2 \\theta - \\sin^2 \\theta";
export const CnomFormula = `\\displaystyle c_{_{nom}} = \\frac{D + a - Da}{2}`;
export const RcdFormula = `\\displaystyle R_{c,d} = \\frac{R_{c,k}}{Ym}`;
export const nFormula = `\\displaystyle \\eta = \\frac{F_{d}}{R_{c,d}}`;

//---------------------------------------------------------------

// TODO: @alex pls fix. Either move all (prefered) or clean up

//E-Modul
const E_Formula = `\\displaystyle E = \\frac{EA_{s}}{A_{s}}`;
//Trägkeitsmoment
const I_Formula = `\\displaystyle I = \\frac{\\pi}{64} \\cdot \\left( D_{a,cal}^4 - D_{i}^4 \\right)`;
//Widerstandsmoment
const W_s_Formula = `\\displaystyle W_{s} = \\frac{\\pi}{32}\\cdot\\frac{\\left( D_{a,cal}^4-D_{i}^4\\right)}{D_{a,cal}}`;
//Querschnitt Verpresskörper
const A_c_Formula = `\\displaystyle A_{c} = \\frac{\\pi}{4}\\cdot\\left( D_{c^2}-D_{a,cal^2}\\right)`;

//Bemessungswert der Normalkraft-Tragfähigkeit	NRd =	1.527	[kN]
const N_Rd_Formula = `\\displaystyle N_{Rd} = A_{s} \\cdot  \\frac{f_{yk}}{\\gamma_{M}} + 0,85 \\cdot A_{c} \\cdot 0,85 \\cdot \\frac{f_{ck}}{\\gamma_{c}}`;
const M_Rd_Formula = `\\displaystyle M_{\\tiny{Rd}} = W_{s} \\cdot \\frac{f_{yk}}{\\gamma_{M}}`;

//Fließdruck
const q_y_Formula = `\\displaystyle q_{y} = k_{c} \\cdot D_{c} \\cdot \\frac{c_{u,k}}{\\gamma_{cu}}`;

//elastischer Bereich der seitlichen Bettung
const w_y_Formula = `\\displaystyle w_{y} = k_{y} \\cdot D_{c}`;

//Bettungsziffer
const c_Formula = `\\displaystyle c = \\frac{q_{y}}{w_{y}}`;

//Anzahl Halbwellen
const m_Formula = `\\displaystyle m = \\frac{L}{\\pi} \\cdot \\sqrt[4]{\\frac{c}{EI_{s}}}`;

//Halbwellenlänge
const L_Hw_Formula = `\\displaystyle L_{Hw} = \\frac{L}{m}`;

//Schlankheit des Ersatzstabes
const gamma_quer_Formula = `\\displaystyle \\overline{\\lambda} = \\sqrt{\\frac{A_{s} \\cdot f_{yk}}{\\overline{N}_{ki}}}`;

//Knicklast des Ersatzstabes
const quer_N_ki_Formula = `\\displaystyle \\overline{N}_{ki} = \\frac{\\pi^2 \\cdot EI_{s}}{L_{Hw}^2}`;

//Knicklast des gebetteten Pfahls
const N_ki_Formula = `\\displaystyle N_{ki} = \\overline{N}_{ki} + \\frac{c \\cdot L_{Hw}^2}{\\pi^2}`;

//Ersatzimperfektionsamplitude
const e_0__Formula = `\\displaystyle \\e_{0} = \\alpha \\cdot \\left(\\overline{\\lambda} - 0,2 \\right) \\cdot \\frac{W_{s}}{A_{s}}`;

//Biegemoment des Pfahls
const M_fd_Formula = `\\displaystyle M_{Fd} = N_{Fd} \\cdot e_{0} \\cdot \\left[ \\frac{\\overline{N_{ki}}}{N_{ki} - N_{Fd}} \\right]`;

//Verformungsamplitude w_0
const w_0_Formula = `\\displaystyle w_{0} = e_{0} \\cdot \\frac{N_{Fd}}{N_{ki} - N_{Fd}}`;

//Querschnittsnachweis
const eta_0_Formula = `\\displaystyle \\eta = \\frac{N_{Fd}}{N_{Rd} + \\frac{M_{Fd}}{M_{Rd}} \\el 1,0`;

//Verformungsbegrenzung

const eta_1_Formula = `\\displaystyle \\eta = \\frac{w_{0}}{w_{y}} \\el 1,0`;

//Knicklänge
const L_crFormula = `\\displaystyle L_{cr} = \\beta \\cdot L`;

//Trägheitsradius
const i_Formula = `\\displaystyle i = \\sqrt{\\frac{I}{A_{s}}}`;

//Bezugsschlankheitsgrad
const lambda_oneFormula = `\\displaystyle \\lambda_{1} = \\pi \\cdot \\sqrt{\\frac{E}{f_{y,k}}}`;

//Bezogener Schlankheitsgrad
const lambda_strichFormula = `\\displaystyle \\overline{\\lambda} = \\frac{L_{cr}}{i \\cdot \\lambda_{1}}`;

//Abminderungsfaktor
const chi_Formula = `\\displaystyle \\chi = \\frac{1}{\\Phi + \\sqrt{\\Phi^2-\\bar{\\lambda}^2}}`;
const phi_Formula = `\\displaystyle \\Phi = 0,5 \\cdot \\left[ 1 + \\alpha \\cdot \\left( \\overline{\\lambda} - 0,2\\right) + \\overline{\\lambda}^2\\right]`;
//const chi_Formula = `\\displaystyle \\chi = \\frac{1}{\\Phi + \\sqrt{\\Phi^2-\\bar{\\lambda}^2}}`;

//Ausnutzung
const eta_one_Formula = `\\displaystyle \\eta = \\frac{F_{d}}{N_{b,Rd}} \\le 1,0`;

//---------------------------------------------------------------
// ------- Aussere --------------------

const R_d_Formula = `\\displaystyle R_{d} = \\pi \\cdot \\left( D + a \\right) \\cdot \\frac{q_{sk}}{\\gamma_{s}`;
export const eta_Formula = `\\displaystyle \\eta = \\frac{F_{d}}{R_{d,nom}}`;
export const eta_druck_Formula = `\\displaystyle \\eta = \\frac{F_{d}}{R_{s,d}}`;
const R_d_pg_Formula = `\\displaystyle R_{d} = U \\cdot \\frac{q_{sk}}{\\gamma_{s}}`;
const R_d_zug_Formula = `\\displaystyle R_{d} = \\pi \\cdot \\left( D + a\\right) \\cdot \\frac{1_{sk}}{\\gamma_{s,t} \\cdot \\eta_{\\small{M}}}`;
const eta_zug_Formula = `\\displaystyle \\eta = \\frac{F_{d}}{R_{d,nom}}`;
//const G_Ek_Formula = `\\displaystyle G_{E,k} = n_{Z} \\cdot \\left[ l_a \\cdot l_b \\left( L - \\frac{1}{3} \\cdot \\sqrt{l_a^2 + l_b^2} \\cdot \\cot \\varphi \\right )\\right] \\cdot \\eta \\cdot \\gamma`;
export const f_bd_Formula = `\\displaystyle f_{bd} = 2,25 \\cdot \\eta_{\\small{1}} \\cdot \\eta_{\\small{2}} \\cdot \\frac{f_{ctk,0,05}}{\\gamma_{c}}`;
export const l_b_Formula = `\\displaystyle l_{\\small{b}} = \\frac{F_d}{\\pi \\cdot D_a \\cdot f_{\\small{bd}}}`;

export const GEkFormula = `\\displaystyle G_{E,k} = n_{z}\\cdot\\left[ l_{a}\\cdot l_{b}\\left({L - \\frac1{3}\\cdot\\sqrt{l_{a}^2+l_{b}^2}} \\cdot \\cot \\varphi \\right) \\right] \\cdot \\eta \\cdot\\gamma`;
export const LreqFormula = `\\displaystyle L_{req} = \\frac{G_{dst,k}\\cdot\\gamma_{\\small{G,dst}}+Q_{dst,rep}\\cdot\\gamma_{\\small{Q,dst}}-G_{stb,k}\\cdot\\gamma_{G,stb}}{\\gamma_{G,stb}\\cdot\\left( l_{a}\\cdot l_{b}\\cdot\\eta\\cdot\\gamma\\cdot n_{z}\\right)}+{\\frac{1}{3}\\cdot\\sqrt{l_{a}^2+l_{b}^2}\\cdot\\cot\\varphi}`;

const R_cu_ashto = `\\displaystyle R_{\\small{CU} = \\Phi_{CU}R_{n}`;
//---------------------------------------------------------------
